import { Injectable } from '@angular/core';
import { AnswerModel } from '../models/answer.model';
import { PdfDocumentPropertiesExtractor } from 'ngx-extended-pdf-viewer';

@Injectable()
export class PdfMetadataService {
  private answerMetadataName = 'TXdocsAnswerVersion';
  // documentPropertiesExtractor = new PdfDocumentPropertiesExtractor();

  public readAnswersMetadata(): Promise<string> {
    return new Promise((resolve, reject) => {
      // call the ngx-extended-pdf-viewer method after we put it in there
      this.getCustomProperty(this.answerMetadataName)
        .then((value) => {
          resolve(value);
        })
        .catch((error) => {
          console.error(error);
          resolve('');
        });
    });
  }

  public hashDbAnswers(answers: AnswerModel[], formData: { [fieldName: string]: any }): Promise<string> {
    return new Promise((resolve, reject) => {
      let hashSource: string = '';

      Object.keys(formData)
        .sort()
        .forEach((key) => {
          const fieldName = key.trim();
          let token = key.slice(0, 7);
          let dimIndex = '';
          let value = formData[key];
          let newValue = value;
          if (key.indexOf('[') > -1) {
            token = key.slice(0, 6) + key.slice(-2, -1);
            dimIndex = key.slice(7, -3);
          }

          const answer = answers.find((a) => a.token === token && a.dimIndex === dimIndex);
          if (answer) {
            if (answer.answer === 'false') {
              newValue = 'Off';
            } else {
              newValue = answer.answer;
            }

            if (value !== newValue) {
              value = newValue;
            }
          }

          const fieldValue = value.toString().replace(/[\x00-\x1F]/g, '');
          hashSource = hashSource + `${fieldName}=${fieldValue}\n`;
        });

      console.log('db answers hash source', hashSource);

      this.getsha256Hash(hashSource)
        .then((hash) => {
          resolve(hash);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public hashDocumentAnswers(formData: { [fieldName: string]: any }): Promise<string> {
    return new Promise((resolve, reject) => {
      let hashSource: string = '';
      Object.keys(formData)
        .sort()
        .forEach((key) => {
          const fieldName = key.trim();
          // remove all characters with ASCII value < 32
          let fieldValue = formData[key];
          if (fieldValue !== undefined && fieldValue !== null) {
            if (fieldValue === false) {
              fieldValue = 'Off';
            }
            fieldValue = fieldValue.toString().replace(/[\x00-\x1F]/g, '');
          } else {
            fieldValue = '';
          }
          hashSource = hashSource + `${fieldName}=${fieldValue}\r\n`;
        });

      console.log('doc answers hash source', hashSource);

      this.getsha256Hash(hashSource)
        .then((hash) => {
          resolve(hash);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private getsha256Hash(hashSource: string): Promise<string> {
    return new Promise((resolve, reject) => {
      // Convert the string to an ArrayBuffer
      const buffer = new TextEncoder().encode(hashSource);

      // Create the SHA-256 hash
      crypto.subtle
        .digest('SHA-256', buffer)
        .then((hashBuffer) => {
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');

          resolve(hashHex);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private async getDocumentCustomProperties(): Promise<any> {
    const PDFViewerApplication: any = (window as any).PDFViewerApplication;
    const pdfDocument = PDFViewerApplication.pdfDocument;
    const md = await pdfDocument.getMetadata();
    const customProperties = (md.info as unknown as any)?.Custom;

    return customProperties;
  }

  private async getCustomProperty(propertyName: string): Promise<string> {
    const customProperties = await this.getDocumentCustomProperties();

    if (!customProperties) {
      return '';
    }

    const result = customProperties[propertyName] ?? '';
    return result;
  }

  private uint8ArrayToBase64(uint8Array: Uint8Array): string {
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) {
      binaryString += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binaryString);
  }
}
